var _path, _path2, _g, _circle, _path3, _path4, _rect, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 72,
    height: 93
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -29,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 39,
    r: 3,
    fill: "#F0B81E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 46L42 59H57L49.5 46Z",
    fill: "#E6CE8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 39L27 59H50L38.5 39Z",
    fill: "#F0B81E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 48,
    height: 20,
    rx: 3,
    fill: "#F0B81E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2706 82.5V72.3182H13.4766C14.2389 72.3182 14.8968 72.4673 15.4503 72.7656C16.0071 73.0606 16.4363 73.4732 16.7379 74.0036C17.0395 74.5305 17.1903 75.1437 17.1903 75.843C17.1903 76.5457 17.0362 77.1605 16.728 77.6875C16.4231 78.2112 15.9872 78.6172 15.4205 78.9055C14.8537 79.1939 14.1809 79.3381 13.402 79.3381H10.8068V77.3991H12.9446C13.3158 77.3991 13.6257 77.3345 13.8743 77.2053C14.1262 77.076 14.3168 76.8954 14.446 76.6634C14.5753 76.428 14.6399 76.1546 14.6399 75.843C14.6399 75.5282 14.5753 75.2564 14.446 75.0277C14.3168 74.7957 14.1262 74.6167 13.8743 74.4908C13.6224 74.3648 13.3125 74.3018 12.9446 74.3018H11.7315V82.5H9.2706ZM27.0689 72.3182V82.5H24.9808L20.929 76.6236H20.8643V82.5H18.4034V72.3182H20.5213L24.5284 78.1847H24.6129V72.3182H27.0689ZM35.2981 75.6442C35.2418 75.4354 35.1589 75.2514 35.0495 75.0923C34.9402 74.9299 34.8059 74.7924 34.6468 74.6797C34.4877 74.567 34.3055 74.4825 34.1 74.4261C33.8945 74.3665 33.6691 74.3366 33.4238 74.3366C32.93 74.3366 32.5024 74.456 32.1412 74.6946C31.7832 74.9332 31.5065 75.2812 31.3109 75.7386C31.1154 76.1927 31.0176 76.7446 31.0176 77.3942C31.0176 78.0471 31.112 78.6039 31.301 79.0646C31.4899 79.5253 31.7633 79.8767 32.1213 80.1186C32.4792 80.3606 32.9134 80.4815 33.4238 80.4815C33.8746 80.4815 34.2557 80.4086 34.5673 80.2628C34.8822 80.1136 35.1208 79.9032 35.2832 79.6314C35.4456 79.3596 35.5268 79.0398 35.5268 78.6719L35.9842 78.7266H33.5083V76.9318H37.8983V78.2791C37.8983 79.1906 37.7044 79.9711 37.3166 80.6207C36.9321 81.2704 36.4018 81.7692 35.7257 82.1172C35.0529 82.4652 34.2789 82.6392 33.4039 82.6392C32.4328 82.6392 31.5794 82.4287 30.8436 82.0078C30.1078 81.5869 29.5344 80.987 29.1234 80.2081C28.7124 79.4259 28.5069 78.4979 28.5069 77.424C28.5069 76.5888 28.6312 75.848 28.8798 75.2017C29.1284 74.5521 29.4747 74.0019 29.9189 73.5511C30.3663 73.1004 30.8833 72.759 31.47 72.527C32.06 72.295 32.6947 72.179 33.3741 72.179C33.9641 72.179 34.5126 72.2635 35.0197 72.4325C35.5301 72.6016 35.9809 72.8402 36.372 73.1484C36.7664 73.4567 37.0862 73.8229 37.3315 74.2472C37.5768 74.6714 37.7292 75.1371 37.7889 75.6442H35.2981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPng);
export default __webpack_public_path__ + "static/media/ico_png.523d63a6714164815f7a583b84b5ab60.svg";
export { ForwardRef as ReactComponent };